import { get } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import DataTable from '../modules/DataTable';
import { importData, toggleSort } from '../modules/DataTable/actions';
import { fetchData } from '../actions/gridDataTable';

const GridDataTable = props => (
    <DataTable
        stateKey={props.stateKey}
        config={props.config}
    />
);

GridDataTable.propTypes = {
    stateKey: PropTypes.string.isRequired,
    config: PropTypes.object.isRequired,
    onMount: PropTypes.func,
    onBeforeSort: PropTypes.func,
    onAfterSort: PropTypes.func,
    onBeforeUpdate: PropTypes.func,
    onAfterUpdate: PropTypes.func
};

function mapStateToProps(state, ownProps) {
    const { dataTable } = get(state, ownProps.stateKey);

    return {
        header: dataTable.header,
        rows: dataTable.rows,
        selectedRows: dataTable.selectedRows,
        loading: dataTable.loading,
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    const update = (url, data) => {
        const afterActions = [];
        ownProps.onAfterUpdate && afterActions.unshift(ownProps.onAfterUpdate);
        ownProps.onBeforeUpdate && ownProps.onBeforeUpdate();

        if (data) {
            return dispatch(importData(ownProps.stateKey, data, afterActions));
        }

        return dispatch(fetchData(ownProps.stateKey, url, afterActions));
    };

    const sort = (columnName, url) => {
        const afterActions = [];
        ownProps.onAfterUpdate && afterActions.push(ownProps.onAfterUpdate);
        ownProps.onAfterSort && afterActions.push(() => ownProps.onAfterSort(columnName));
        ownProps.onBeforeSort && ownProps.onBeforeSort(columnName);
        ownProps.onBeforeUpdate && ownProps.onBeforeUpdate();

        dispatch(toggleSort(ownProps.stateKey, columnName));

        return dispatch(fetchData(ownProps.stateKey, url, afterActions));
    };

    return { sort, update, };
}

function mergeProps(stateProps, dispatchProps, ownProps) {
    return Object.assign(
        {},
        stateProps,
        dispatchProps,
        ownProps,
        {
            update: (url, data) =>
                !stateProps.loading && dispatchProps.update(url || stateProps.url, data),
            sort: (columnName, url) =>
                !stateProps.loading && dispatchProps.sort(columnName, url),
        }
    );
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(DataTable);



// WEBPACK FOOTER //
// ./src/js/containers/GridDataTable.js